import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MapPinHouse, Phone } from "lucide-react";

const BannerNew = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const contactInfo = [
    {
      icon: "📞",
      text: "",
    },
    {
      icon: "📍",
      text: "",
    },
  ];

  const bannerData = [
    {
      title:
        "Innovative Facilities Management for a Smarter Tomorrow",
      subtitle:
        "End-to-End Facilities Management Services for Peak Efficiency",
      image: "/images/homepageucwf/banner/ifm-main-banner.webp",
      link: "/service/ifm-services",
      style: "linear-gradient(300deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1))",
    },
    {
      title: "Essential Hard Services for Enhanced Durability and Efficiency",
      subtitle:
        "Cost-Effective Hard Services Maintenance Strategies for Property Owners",
      image: "/images/homepageucwf/banner/electric-main-banner.webp",
      link: "/service/hard-services",
      style: "linear-gradient(300deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1))",
      // style: "",
    },
    {
      title: "Soft Services That Elevate Comfort, Hygiene and Productivity",
      subtitle:
        "Housekeeping Services: A Key Component of Sustainable Facility Management",
      image: "/images/homepageucwf/banner/cleaning-main-banner.webp",
      link: "/service/soft-services",
      style: "",
      // style: "linear-gradient(120deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3))"
    },
    {
      title: "Ensuring Safety and Protection with Leading Security Services",
      subtitle:
      "Smart, Reliable and Proactive Security Solutions",
      image: "/images/homepageucwf/banner/security-main-banner.webp",
      link: "/service/security-services",
      style: "",
      // style: "linear-gradient(120deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3))"
    },
    {
      title: "Expert Care for Fire System, Elevators and ELV Equipment ",
      subtitle:
        "Reliable and Professional Maintenance for Critical Facility Systems",
      image: "/images/homepageucwf/banner/elevator-main-banner.webp",
      link: "/service/specialized-services",
      style: "linear-gradient(300deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1))",
      // style: "",
    },
    {
      title: "Driving Sustainability with Innovative, Eco-Friendly Facility Solutions ",
      subtitle:
        "UCWF: Empowering Sustainable Growth for a Better Tomorrow",
      image: "/images/homepageucwf/banner/sustainability-main-banner.webp",
      link: "/sustainability",
      style: "linear-gradient(300deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1))",
      // style: "",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: false,
    beforeChange: (current, next) => setActiveSlide(next),
    dotsClass: "slick-dots customnew-dots",
    fade: true,
    lazyLoad: "progressive",
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    // Preload images for smoother transitions
    bannerData.forEach((item) => {
      const img = new Image();
      img.src = item.image;
    });

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const getTransformStyle = () => {
    if (isMobile) {
      return {
        transform: `translateY(${scrollPosition * -0.3}px)`,
        opacity: Math.max(1 - scrollPosition / 500, 0),
      };
    }
    return {
      transform: `translateX(${scrollPosition * -0.3}px)`,
      opacity: Math.max(1 - scrollPosition / 500, 0),
    };
  };

  return (
    <div className="bannernew-wrapper">
      {/* // Update the contact info rendering section: */}
      
      <Slider {...settings} className="bannernew-slider">
        {bannerData.map((item, index) => (
          <div key={index} className="bannernew-slide-wrapper">
            <div
              className="bannernew"
              style={{
                // backgroundImage: `linear-gradient(120deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3)), url(${item.image})`,
                backgroundImage: item.style
                  ? `${item.style}, url(${item.image})`
                  : `url(${item.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                imageRendering: "-webkit-optimize-contrast",
              }}
            >
              <div className="container h-full">
                <div className="contentnew-wrapper">
                  <div className="bannernew-content">
                    <div
                      className={`slidenew-content ${
                        activeSlide === index ? "active" : ""
                      }`}
                      style={getTransformStyle()}
                    >
                      <div className="titlenew-wrapper">
                        <h1 className="titlenew ">{item.title}</h1>
                      </div>
                      <p className="subtitlenew">{item.subtitle}</p>
                      <div className="buttonnew-wrapper">
                        <Link to={item.link} className="ctanew-button">
                          <span className="buttonnew-text">Get Started →</span>
                          <span className="buttonnew-shine"></span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BannerNew;
